import React from 'react';

interface ProgressIndicatorProps {
  current: number;
  total: number;
  percentage: number;
  showNumbers?: boolean;
  className?: string;
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  current,
  total,
  percentage,
  showNumbers = true,
  className = ''
}) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Barra de progreso */}
      <div className="flex-1 bg-gray-200 rounded-full h-2 min-w-[100px]">
        <div
          className="bg-blue-600 h-2 rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Números de progreso */}
      {showNumbers && (
        <span className="text-sm font-medium text-gray-600 whitespace-nowrap">
          {current}/{total}
        </span>
      )}

      {/* Porcentaje */}
      <span className="text-sm font-medium text-blue-600 whitespace-nowrap">
        {percentage}%
      </span>
    </div>
  );
};